var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualRainGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2FEC4D09-E944-4727-8AB8-21025483F69A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-34.4%",
    y: "-34.4%",
    width: "168.8%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-with-VRG",
    transform: "translate(-327.000000, -406.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker/virtualRainGauge",
    transform: "translate(330.000000, 407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    filter: "url(#filter-1)",
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 3,
    fill: "#F13077",
    cx: 16,
    cy: 16,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.500000, 8.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,10.5 C1.34314575,10.5 2.02906125e-16,9.15685425 0,7.5 C-1.44932947e-17,7.38165327 0.00685278444,7.26490709 0.020183194,7.15013662 C0.00698827134,7.01560236 0,6.88361728 0,6.75 C0,4.85043065 1.41239061,3.28074281 3.24430183,3.03380648 C3.85150774,1.26903416 5.52755447,0 7.5,0 C9.98528137,0 12,2.01471863 12,4.5 L12,4.5 C13.6568542,4.5 15,5.84314575 15,7.5 C15,9.15685425 13.6568542,10.5 12,10.5 L3,10.5 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 13.5,
    x2: 1.95,
    y2: 15.9,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 13.5,
    x2: 5.7,
    y2: 15.9,
    id: "Line-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.25,
    y1: 13.5,
    x2: 9.45,
    y2: 15.9,
    id: "Line-Copy-2",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.000000, 4.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F13077",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 11,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 11,
    y2: 7,
    id: "Line-2-Copy"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualRainGauge);
export default __webpack_public_path__ + "static/media/VirtualRainGauge.ccfb3640f485de1696a2d8fa16bc23b4.svg";
export { ForwardRef as ReactComponent };